import { AdAnalyticsReport } from '@kaizenplatform/hugot-entity';
import { List } from 'immutable';

import State from '../core/State';

// Detail
export const startFetchingAdAnalyticsReport = () => (state: State): State => ({
  ...state,
  adAnalyticsReport: {
    ...state.adAnalyticsReport,
    fetching: state.adAnalyticsReports.fetching + 1,
  },
});

export const finishFetchingAdAnalyticsReport = () => (state: State): State => ({
  ...state,
  adAnalyticsReport: {
    ...state.adAnalyticsReport,
    fetching: state.adAnalyticsReports.fetching - 1,
  },
});

export const setAdAnalyticsReport = (adAnalyticsReport: AdAnalyticsReport) => (state: State): State => ({
  ...state,
  adAnalyticsReport: {
    ...state.adAnalyticsReport,
    item: adAnalyticsReport,
  },
});

export const disposeAdAnalyticsReport = () => (state: State): State => ({
  ...state,
  adAnalyticsReport: {
    ...state.adAnalyticsReport,
  },
});

// List
export const startFetchingAdAnalyticsReports = () => (state: State): State => ({
  ...state,
  adAnalyticsReports: {
    ...state.adAnalyticsReports,
    fetching: state.adAnalyticsReports.fetching + 1,
  },
});

export const finishFetchingAdAnalyticsReports = () => (state: State): State => ({
  ...state,
  adAnalyticsReports: {
    ...state.adAnalyticsReports,
    fetching: state.adAnalyticsReports.fetching - 1,
  },
});

export const setAdAnalyticsReports = (adAnalyticsReports: List<AdAnalyticsReport>) => (state: State): State => ({
  ...state,
  adAnalyticsReports: {
    ...state.adAnalyticsReports,
    items: adAnalyticsReports,
  },
});

export const disposeAdAnalyticsReports = () => (state: State): State => ({
  ...state,
  adAnalyticsReports: {
    ...state.adAnalyticsReports,
  },
});

export const setSubmitComment = (success: boolean) => (state: State): State => ({
  ...state,
  adAnalyticsReport: {
    ...state.adAnalyticsReport,
    submitComment: success,
  },
});
